import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaRecibosGenerador', {
    template: template,
    controller: NominasNominaRecibosGeneradorComponent,
    bindings: {
      idNomina: '<',
      data: '<',
    },
  })

function NominasNominaRecibosGeneradorComponent(NominasNominaRecibos, $file, $zip) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.generarZip = generarZip

  function $onInit() {
    $ctrl.generados = 0
    $ctrl.total = $ctrl.data.length
    $ctrl.completado = 0
    $ctrl.comprimiendo = false
    $ctrl.multiples = 5
    $ctrl.generando = []

    $ctrl.data.forEach(function (item) {
      item.status = undefined
      item.activo = false
      item.generando = false
      item.documento = undefined

      item.generar = function () {
        item.status = 'generando'
        item.activo = true
        item.generando = true

        return NominasNominaRecibos.descargar(item.ID_Empresa, item.ID_Empleado, $ctrl.idNomina, item.enviarEmail)
          .then(function (response) {
            item.status = 'completado'
            item.documento = response.data
          })
          .catch(function (response) {
            item.status = 'error'
            item.documento = null
            item.error = response.data
          })
          .finally(function () {
            item.generando = false
          })
      }
    })

    generarSiguiente()
  }

  function generarSiguiente() {
    let generando = 0
    $ctrl.data.forEach(function (item) {
      if ((generando < $ctrl.multiples) && !item.activo)
        item.generar()
          .then(function () {
            $ctrl.generados++
            generarSiguiente()
          })

      if (item.generando)
        generando++
    })
  }

  function generarZip() {
    $ctrl.comprimiendo = true
    let filename = 'Estados de cuenta Nómina ' + $ctrl.idNomina + '.zip',
      files = angular.copy($ctrl.data)
        .filter(function (item) {
          return item.documento
        })
        .map(function (item) {
          return {
            name: $ctrl.idNomina + '-' + item.Empleado + '.pdf',
            content: item.documento,
          }
        })

    return $zip().then(function (zip) {
      files.forEach(function (document) {
        zip.file(document.name, document.content)
      })

      return zip
        .generateAsync({type: 'blob', compression: 'DEFLATE', mimeType: 'application/zip'})
        .then(function (content) {
          $ctrl.zip = content
          $file.saveAs($ctrl.zip, filename)
        })
    }).finally(function () {
      $ctrl.comprimiendo = false
      $ctrl.completado = true
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/recibos/generador/component.js